import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { BestServiceAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { HeaderSection, FooterSection, LeafBox, Accordion } from '@components'

import './BisnisDetail.scss'
import { TitleComponent } from '../../../common/components/TitleComponent'
const Container = styled.div`
  background-color: #ffffff;
  padding-top: 76px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const BisnisDetail = function () {
  const { t } = useTranslation()

  const { id } = useParams()
  const [data, setdata] = useState({})
  const [isLoading, setisLoading] = useState(false)

  const loadData = async function () {
    setisLoading(true)
    const reportData = await BestServiceAPI(`/${id}`)
    setdata(reportData.data.data)
    setisLoading(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="saving-detail">
          {data.buttonUrl !== null ? (
            <div>
              <Desktop>
                <HeaderSection
                  title={data.title}
                  group={t('your_business_solution')}
                  description={data.description}
                  banner={data.imageBannerDesktop}
                  linkButton={data.buttonUrl}
                  textButton={t('button_bisnis_service')}
                  showButton={true}
                />
              </Desktop>
              <Mobile>
                <HeaderSection
                  title={data.title}
                  group={t('your_business_solution')}
                  description={data.description}
                  banner={data.imageBannerMobile}
                  linkButton={data.buttonUrl}
                  showButton={true}
                  textButton={t('button_bisnis_service')}
                />
              </Mobile>
            </div>
          ) : (
            <div>
              <Desktop>
                <HeaderSection
                  title={data.title}
                  group={t('your_business_solution')}
                  description={data.description}
                  banner={data.imageBannerDesktop}
                  showButton={false}
                />
              </Desktop>
              <Mobile>
                <HeaderSection
                  title={data.title}
                  group={t('your_business_solution')}
                  description={data.description}
                  banner={data.imageBannerMobile}
                  showButton={false}
                />
              </Mobile>
            </div>
          )}

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {typeof data.blockDataCard != 'undefined' &&
                data.blockDataCard.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {t('solusi_tabungan_keunggulan', {
                        tabungan: data.title,
                      })}
                    </h2>

                    <div className="row">
                      {data.blockDataCard.map((item, index) => {
                        return (
                          <LeafBox
                            key={index}
                            size={4}
                            number={index + 1}
                            title={item.titleDataCard}
                            description={item.descriptionDataCard}
                          />
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.blockDataAccordion1 != 'undefined' &&
                data.blockDataAccordion1.length > 0 && (
                  <div>
                    {data.id === '2142' ? (
                      <div className="mb-5">
                        <div className="row mt-4">
                          <Accordion
                            title={
                              data.blockDataAccordion1[0].subTitleAccordion
                            }
                          >
                            {data.blockDataAccordion1[0].contentAccordion}
                          </Accordion>
                        </div>
                        <h2 className="mt-5 mb-4 section-title">
                          {data.accordionTitle}
                        </h2>
                        <div className="row">
                          <Accordion
                            title={
                              data.blockDataAccordion2[0].subTitleAccordion
                            }
                          >
                            {data.blockDataAccordion2[0].contentAccordion}
                          </Accordion>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-5">
                        <h2 className="mt-5 mb-4 section-title">
                          {data.accordionTitle}
                        </h2>

                        {data.id === '2136' || data.id === '2135' ? (
                          <div className="row">
                            {data.blockDataAccordion1.map((item, index) => {
                              return (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.contentAccordion,
                                  }}
                                ></p>
                              )
                            })}
                          </div>
                        ) : (
                          <div className="row">
                            {data.blockDataAccordion1.map((item, index) => {
                              return (
                                <Accordion
                                  key={index}
                                  title={item.subTitleAccordion}
                                >
                                  {item.contentAccordion}
                                </Accordion>
                              )
                            })}
                            {data.blockDataAccordion2.map((item, index) => {
                              return (
                                <Accordion
                                  key={index}
                                  title={item.subTitleAccordion}
                                >
                                  {item.contentAccordion}
                                </Accordion>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>
        </div>
      )}

      <FooterSection currentPage={t('layanan_bisnis')} />
    </Container>
  )
}

export default BisnisDetail
